import React from 'react';

const cardClassName =
  'bg-white rounded-lg sm:rounded-xl shadow-card sm:p-0 md:p-2 lg:p-4  hover:shadow-card-hover transition-shadow';
const headerClassName = 'flex justify-between items-start mb-3 sm:mb-4';
const titleClassName = 'text-base sm:text-lg font-semibold text-gray-900 mb-1 truncate';
const subtitleClassName = 'text-xs sm:text-sm text-gray-600 line-clamp-2';
const iconWrapClassName = 'text-gray-400 hover:text-gray-600 cursor-pointer ml-2 flex-shrink-0';

function ChartCard({
  title,
  subtitle,
  children,
  icon,
  showHeader = true,
}) {
  return React.createElement(
    'div',
    { className: cardClassName },
    showHeader &&
      React.createElement(
        'div',
        { className: headerClassName },
        React.createElement(
          'div',
          { className: 'flex-1 min-w-0' },
          React.createElement('h3', { className: titleClassName }, title),
          React.createElement('p', { className: subtitleClassName }, subtitle)
        ),
        icon && React.createElement('div', { className: iconWrapClassName }, icon)
      ),
    React.createElement('div', { className: 'chart-container' }, children)
  );
}

export default React.memo(ChartCard);
